var map = {
	"./computer/BlockDetail/BlockDetail.vue": [
		"bcfe",
		"chunk-44dcc8f9"
	],
	"./mobile/BlockDetail/BlockDetail.vue": [
		"8b13",
		"chunk-207ae387"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "26aa";
module.exports = webpackAsyncContext;